import $ from "jquery"

// ### trace ###
export const trace = (...str)=> {
  if ($('body').data('mode') == 'dev') {
    console.info(...str);
  }
}

// Scroll to Position
export const scrollToPos = (topPx, time = 800, callback = null)=> {
  let $page = $('html, body');
  $page.animate({ scrollTop: topPx }, time, ()=>{
    if($.isFunction(callback)){
      callback()
    }
  });  
}

// Scroll to $target
export const scrollTo = ($target, offset = 0, time = 800, callback = null)=> {
  if (!$target.length) {
    return false;
  }
  let topPx = $target.offset().top - offset;
  scrollToPos(topPx, time, callback);
}



export const UiHelpers = {


  // bootstrap collapse
  // toggle button label
  initCollapseButtonLabel() {
    $('body').on("shown.bs.collapse hidden.bs.collapse", ".collapse", (e)=> {
      let $collapse = $(e.target);
      let id = $collapse.attr("id");
      let $btn = $('a[href="#' + id + '"]');
      if ($btn.length) {
        let labelCollapsed = $btn.data("labelcollapsed");
        let labelExpanded = $btn.data("labelexpanded");
        if (labelCollapsed && labelExpanded) {
          if ($collapse.hasClass("in")) {
            $btn.html(labelExpanded);
          }
          else {
            $btn.html(labelCollapsed);
          }

        }
      }
    });
  },

  // forn input autofocus
  initFormInputAutofocus() {
    $('input.autofocus').focus();
  },

  init() {
    // collapse toggle btn label
    this.initCollapseButtonLabel();
    // init input.autofocus
    this.initFormInputAutofocus();
  }

}
